'use client';

import ButtonGradient from "@/components/ButtonGradient";
import { staticUrl } from "@/libs/cdn";
import fluentCityImg from "@/public/blog2/article4/en.jpg";
import Image from "next/image";
import type React from "react";
import { styles } from "../_assets/content";

const Article4: React.FC = () => {
  return (
    <>
      <Image
        src={fluentCityImg}
        alt="B1 Level English Exam Preparation"
        width={700}
        height={500}
        priority={true}
        className="rounded-box"
      />
      <section>
        <h3 className={styles.h3}>Why Prepare Specifically for IELTS, TOEFL, TOEIC, or CELPIP?</h3>
        <p className={styles.p}>
          The IELTS, TOEFL, TOEIC, and CELPIP exams certify your English proficiency across various skills – listening, reading, speaking, and writing. These certifications are globally recognized by universities, employers, and institutions. Each test targets different proficiency needs, making focused preparation key to achieving a high score. Whether you need it for education, career opportunities, or immigration, excelling in these exams starts with understanding their structure and setting clear goals.
        </p>
      </section>

      <section>
        <h3 className={styles.h3}>Essential Tips for B1 Level Exam Success</h3>
        <p className={styles.p}>
          Preparing for a B1-level English exam requires a strategic approach:
          <ul className="list-disc ml-5 mt-2">
            <li>Review grammar fundamentals and expand your vocabulary with daily practice.</li>
            <li>Focus on improving writing skills by practicing essays, emails, or reports.</li>
            <li>Enhance listening and speaking skills with language apps, podcasts, and conversation partners.</li>
            <li>Time yourself on mock tests to simulate exam conditions.</li>
          </ul>
        </p>
      </section>

      <section>
        <h3 className={styles.h3}>Free Workbook and Study Materials</h3>
        <p className={styles.p}>
          To boost your preparation, download the B1 workbook from Linpoly.com. It provides comprehensive exercises tailored for IELTS, TOEFL, TOEIC, and CELPIP candidates. With structured lessons and real-world examples, this resource helps you build confidence and improve weak areas.
        </p>
        <p className="mt-10">
        <ButtonGradient 
          title="Download for free" 
          onClick={() => {
            const link = document.createElement('a');
            link.href = staticUrl("/workbooks/Linpoly-English-Workbook-B1.pdf");
            link.setAttribute('download', 'Linpoly-English-Workbook-B1.pdf');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }} 
        />
        </p>
      </section>

      <section>
        <h3 className={styles.h3}>Strategies for Staying Consistent</h3>
        <p className={styles.p}>
          Consistency is key to success. Set a daily study schedule, track your progress, and reward yourself for milestones. Remember, small improvements every day lead to big achievements.
        </p>
      </section>

      <section>
        <h3 className={styles.h3}>Get Started Today</h3>
        <p className={styles.p}>
          Don’t wait – download your free workbook and start preparing for your B1-level exam now. With the right materials, tips, and a dedicated approach, success is within your reach.
        </p>
      </section>
    </>
  );
};

export default Article4;